export default "__VITE_ASSET__55ftYI0e__"